// extracted by mini-css-extract-plugin
export default {"skillsWrapper":"SkillsForm_skillsWrapper__A9KAg","skill":"SkillsForm_skill__231uD","skillAdded":"SkillsForm_skillAdded__nITn6","skillsForm":"SkillsForm_skillsForm__7vQcl"};